export default val => {
  if (Array.isArray(val)) {
    return val.length > 0;
  }
  if (typeof val === 'string') {
    return val !== '';
  }
  return val !== undefined && val !== null && val !== 0;
};
